<template>
  <el-dialog :visible.sync="dialogVisible" @opened="dialogOpen" @closed="dialogClose" center width="90%" top='40px'
    v-loading="loading" element-loading-text="加载中..." @open="stopSrcoll()" @close="openSrcoll()">
    <task-common :listDetialData="listDetialData" :name='name' ref="task" @close='dialogClose' @message='onReadload' />
  </el-dialog>
</template>
<script>
  import * as indexService from "@/api/sys/index";
  import TaskCommon from "./TaskCommon";
  import form from "@/libs/form";
  import _ from "lodash";
  export default {
    name: "listTaskDetial",
    components: {
      TaskCommon
    },
    props: {
      listDetialData: Object,
      name: String,
      value: Boolean,
    },
    data() {
      return {
        loading: false,
        dialogVisible: false,
      };
    },
    watch: {
      value(val) {
        this.dialogVisible = val;
      },
      dialogVisible(val) {
        this.$emit("input", val);
      },
    },
    computed: {},
    methods: {
      dialogOpen() {
        let shortTitle = this.listDetialData.Type;
        if (this.listDetialData.isRead == false) {
          let configID = {
            configID: this.listDetialData.configID,
          };
          indexService.IsReadListData(configID).then((data) => {
            this.$refs.task.GetRootConfigValue(shortTitle);
            this.$emit("submit");
          });
        } else {
          this.$refs.task.GetRootConfigValue(shortTitle);
        }
      },
      
      dialogClose() {
        this.dialogVisible = false;
        this.$refs.task.close();
      },
      onReadload(){
        this.$emit("submit");
      },
      stopSrcoll() {
        var mo = function (e) {
          e.preventDefault();
        };
        document.body.style.overflow = 'hidden';
        document.addEventListener("touchmove", mo, false); //禁止页面滑动
      },
      openSrcoll() {
        var mo = function (e) {
          e.preventDefault();
        };
        document.body.style.overflow = ''; //出现滚动条
        document.removeEventListener("touchmove", mo, false);
      },
    },
  };
</script>
<style lang="scss" scoped>
  /deep/ .el-dialog__body {
    padding: 5px 20px 0 20px;

    &::-webkit-scrollbar {
      // 是否显示
      display: none;
      width: 6px;
      padding-right: 4px;
      background-color: #fff;
    }

    &::-webkit-scrollbar-thumb {
      -webkit-border-radius: 3px;
      border-radius: 3px;
      background-color: #c6c6c6;
    }
  }
</style>